import { Reducer } from "redux";

import { AppConfigsActionDispatchTypes } from "../constants/AppConfigs";
import { AppConfigsResponse } from "../models/api/AppConfigs";
import { AppConfigsDispatchTypes } from "../models/dispatchTypes/AppConfigs";

const initialState: AppConfigsResponse = {
  loading: false,
  response: {
    REACT_APP_PORTAL_HOST_CONFIG: "",
    REACT_APP_PORTAL_DEBUG: true,
    REACT_APP_PORTAL_CLIENT: "",
    REACT_APP_PORTAL_LOGINURL: "",
    REACT_APP_PORTAL_KNOWN_AUTHORIETIES: "",
    REACT_APP_PORTAL_REDIRECT_URI: "",
    REACT_APP_PORTAL_B2C_SCOPE: "",
    REACT_APP_PORTAL_GOOGLE_MAP_KEY: "",
    REACT_APP_PORTAL_MAX_FILE_SIZE: 0,
    REACT_APP_PORTAL_OASIS_UPLOAD: "",
    REACT_APP_PORTAL_NOMNC: "",
    REACT_APP_PORTAL_PROVIDER_FINDER: "",
    REACT_APP_PORTAL_PRIOR_AUTHORIZATION_REQUEST: "",
    REACT_APP_PORTAL_REFERRAL_FORM_NEVADA_ONLY: "",
    REACT_APP_PORTAL_CENTENE_AMBETTER_PA_PA_REQUEST_FORM: "",
    REACT_APP_PORTAL_RESUMPTION_OF_CARE_REQUEST_FORM: "",
    REACT_APP_PORTAL_RE_AUTHORIZATION_REQUEST_FORM: "",
    REACT_APP_PORTAL_START_OF_CARE_CONFIRMATION_FORM: "",
    REACT_APP_PORTAL_FAX_CONFIRMATION_FORM: "",
    REACT_APP_PORTAL_OUT_OF_NETWORK_SERVICE_NOTIFICATION: "",
    REACT_APP_PORTAL_ELECTRONICS_FUNDS_TRANSFER_ENROLLMENT: "",
    REACT_APP_PORTAL_CLAIMS_DISPUTE: "",
    REACT_APP_PORTAL_INFORMATION_CHANGE_FORM: "",
    REACT_APP_PORTAL_PROVIDER_MANUAL: "",
    REACT_APP_PORTAL_MAX_SERVICE_PROVIDER_COUNT: 0,
    REACT_APP_PORTAL_MANAGED_HEALTH_PLAN_LIST: "",
    REACT_APP_PORTAL_FRESHCHAT_URL : "",
    REACT_APP_PORTAL_FRESHCHAT_WIDGET : "",
    REACT_APP_PORTAL_DOCUMENT_MAX_FILE_SIZE : "",
    REACT_APP_PORTAL_TANGO_CARE_UPLOAD_URL: "",
    REACT_APP_PORTAL_SSO_HPS_URL: "",
    REACT_APP_PORTAL_HPS_CLAIMS_STATUS_FORM_URL: "",
    REACT_APP_PORTAL_REPLACE_START: "",
    REACT_APP_PORTAL_REPLACE_END: "",
    REACT_APP_PORTAL_SAML_CALLBACK: "",
        
  },
  error: null,
};

const AppConfigsReducer: Reducer<
  AppConfigsResponse,
  AppConfigsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case AppConfigsActionDispatchTypes.APP_CONFIG_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
      case AppConfigsActionDispatchTypes.APP_CONFIG_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case AppConfigsActionDispatchTypes.APP_CONFIG_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
  }
  return state;
};

export default AppConfigsReducer;